import { Debug, Physics } from "@react-three/rapier";
import Effects from "./Effects.jsx";
import { Level } from "./Level.jsx";
import Lights from "./Lights.jsx";
import Player from "./Player.jsx";
import useGame from "./stores/useGame.jsx";
import { OrbitControls, useGLTF } from "@react-three/drei";
export default function Experience() {
  const blocksCount = useGame((state) => {
    return state.blocksCount;
  });
  const blocksSeed = useGame((state) => {
    return state.blocksSeed;
  });
  console.log(blocksCount);
  return (
    <>
      <color args={["#252731"]} attach="background" />
      <OrbitControls makeDefault />
      <Physics>
        {/* <Debug /> */}
        <Lights />
        <Level count={blocksCount} seed={blocksSeed} />
        <Player />
      </Physics>

      <Effects />
    </>
  );
}
